/**
 * Centralized Step Registry
 *
 * This file contains all step metadata and configuration in one place.
 * Each step component imports from this registry to avoid duplication.
 */

export const STEP_METADATA = {
  identity: {
    key: "identity",
    name: "Identity",
    title: "Explore Identity",
    altTitle: "Identity Activity",
    description: "(15 min)",
    details: "Help your student explore and understand their unique identity",
    image: "/identity.svg",
    type: "youth",
    theme: "brand",
  },
  gifts: {
    key: "gifts",
    name: "Gifts",
    title: "Discover Gifts",
    altTitle: "Gifts Activity",
    description: "(15 min)",
    details: "Discover the God-Given Gifts and strengths that make your student special",
    image: "/gifts.svg",
    type: "youth",
    theme: "gifts",
    extraDetails: () => (
      <div className="text-sm italic">
        Optional Pre-Work: We recommend students complete a strengths assessment from VIA before
        completing this activity. The assessment can be found{" "}
        <a href="http://encircled.pro.viasurvey.org" className="underline hover:font-bold">
          here
        </a>
      </div>
    ),
  },
  vision: {
    key: "vision",
    name: "Vision",
    title: "Clarify Vision",
    altTitle: "Vision Activity",
    description: "(15 min)",
    details: "Work together to create a 1-Year Vision and set meaningful goals",
    image: "/vision.svg",
    type: "youth",
    theme: "vision",
  },
  mentorCircle: {
    key: "mentorCircle",
    name: "Mentors",
    title: "Choose Mentors",
    description: "(15 min)",
    details: "Choose the trusted adults that will form their Mentor Circle",
    image: "/circle.png",
    type: "youth",
    theme: "circle",
  },
  encouragement: {
    key: "encouragement",
    name: "Encouragement",
    title: "Encouragements",
    description: "(10 min)",
    details: "Speak life and encouragement over your student’s journey and future.",
    image: "/encouragement.svg",
    type: "mentors",
    theme: "encouragement",
  },
  commitments: {
    key: "commitments",
    name: "Commitments",
    title: "Commitments",
    description: "(10 min)",
    details: "Commit to specific ways you will support your student this year.",
    image: "/commitments.svg",
    type: "mentors",
    theme: "commitments",
  },
  blessings: {
    key: "blessings",
    name: "Blessing",
    title: "Blessing",
    description: "(10 min)",
    details: "Share a meaningful blessing that affirms your student’s identity and purpose.",
    image: "/blessings.svg",
    type: "mentors",
    theme: "blessings",
  },
}

// Derived arrays for specific use cases
export const StudentActivities = Object.values(STEP_METADATA)
  .filter(step => step.type === 'youth')
  .map(({ title, name, altTitle, description, details, image, extraDetails }) => ({
    title,
    name,
    altTitle,
    description,
    details,
    image,
    extraDetails,
  }))

export const MentorActivities = Object.values(STEP_METADATA)
  .filter(step => step.type === "mentors")
  .map(({ title, name, altTitle, description, details, image, extraDetails }) => ({
    title,
    name,
    altTitle,
    description,
    details,
    image,
    extraDetails,
  }))

// Helper function to get step metadata by key
export const getStepMetadata = (key) => STEP_METADATA[key]

// Helper function to get step metadata by name
export const getStepMetadataByName = (name) => {
  return Object.values(STEP_METADATA).find(step => step.name === name)
}
